<template>
    <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
    >
        <template #button-content>
            <div class="d-sm-flex d-none user-nav">
                <p class="user-name font-weight-bolder mb-0">
                    {{ authUserInfo.email }}
                </p>
                <span class="user-status">
                    {{ authUserInfo.userName }}
                </span>
            </div>
            <b-avatar
                size="40"
                variant="light-primary"
            />
        </template>

        <b-dropdown-item
            v-if="isPopsLogin"
            link-class="d-flex align-items-center"
            @click="goToMyAccountOfPops"
        >
            <feather-icon
                size="16"
                icon="UserIcon"
                class="mr-50"
            />
            <span>
                {{ $t('Profile' )}}
            </span>
        </b-dropdown-item>
        <b-dropdown-item
            v-else
            link-class="d-flex align-items-center"
            @click="goToAuthCenter"
        >
            <feather-icon
                size="16"
                icon="UserIcon"
                class="mr-50"
            />
            <span>
                {{ $t('Profile' )}}
            </span>
        </b-dropdown-item>
        <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="logout"
        >
            <feather-icon
                size="16"
                icon="LogOutIcon"
                class="mr-50"
            />
            <span>
                {{ $t('Logout')}}
            </span>
        </b-dropdown-item>
        <b-dropdown-divider v-if="availableService.length" />
        <b-dropdown-header v-if="availableService.length">
            {{ $t('Available Services') }}
        </b-dropdown-header>
        <b-dropdown-item
            link-class="d-flex align-items-center"
            v-for="(serviceGroup, index) in availableService"
            :key="index"
            @click="moveService(serviceGroup)"
        >
            <span style="text-overflow:ellipsis;overflow:hidden">
                {{ serviceGroup.name.toUpperCase() }}
            </span>
            <b-badge
                v-if="serviceGroup.name === 'notify'"
                pill
                variant="primary"
                class="ml-50"
            >
                {{ $t('new') }}
            </b-badge>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { auth } from '@/auth/hyper-auth'
import { getCurrentInstance, computed } from '@vue/composition-api'
export default {
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const serviceGroups = computed(() => store.getters.authServiceGroups)
        const projects = computed(() => store.getters.projects)
        const myOwnProjects = computed(() => store.getters.myOwnProjects)
        const additionalProjects = computed(() => store.getters.additionalProjects)
        const availableService = computed(() => {
            if (projects.value.length || myOwnProjects.value.length || additionalProjects.value.length) {
                return serviceGroups.value
            } else {
                return serviceGroups?.value?.filter(service => service.name === 'billing-admin')
            }
        })
        const isPopsLogin = process.env.VUE_APP_POPS_LOGIN === 'TRUE' && process.env.VUE_APP_ENV === 'production'
        const goToAuthCenter = () => {
            const token = localStorage.getItem(auth.authConfig.storageTokenKeyName)
            window.open(`${process.env.VUE_APP_AUTH_CENTER_URL}/signin/email/${authUserInfo.value.email}/token/${token}`)
        }
        const goToMyAccountOfPops = () => {
            window.open(process.env.VUE_APP_POPS_MY_ACCOUNT_URL)
        }
        const logout = async () => {
            try {
                await store.dispatch('deleteMemberAuth', { id: authUserInfo.value.userIdx })
            } catch (error) {
                console.error(error)
            }
            localStorage.removeItem(auth.authConfig.storageTokenKeyName)
            window.location.href = '/signin'
        }
        const moveService = (serviceGroup) => {
            const token = localStorage.getItem(auth.authConfig.storageTokenKeyName)
            window.open(`${serviceGroup.domain}/signin/email/${authUserInfo.value.email}/token/${token}`)
        }
        return {
            isPopsLogin,
            authUserInfo,
            availableService,
            goToMyAccountOfPops,
            goToAuthCenter,
            logout,
            moveService
        }
    }
}
</script>

<style>

</style>
